export enum CreditNoteReasonCode {
  CREDIT_PURCHASE = 'CREDIT_PURCHASE',
  ORDER_CANCELLATION = 'ORDER_CANCELLATION',
  ORDER_CHANGE = 'ORDER_CHANGE',
  OTHER = 'OTHER',
  PRODUCT_UNSATISFACTORY = 'PRODUCT_UNSATISFACTORY',
  SERVICE_UNSATISFACTORY = 'SERVICE_UNSATISFACTORY',
  USAGE_CREDIT = 'USAGE_CREDIT',
  WAIVER = 'WAIVER',
}
